<div class="modal-header"><h2>Remove user from account</h2></div>

<div class="modal-body" *ngIf="user">
  <p>
    Are you sure you want to remove <strong>{{ user.name }}</strong> from
    account <strong>{{ accountId }}</strong
    >?
  </p>

  <div *ngIf="error">
    <p class="error-msg">Failed to remove user from account.</p>
    <p class="error-msg">{{ error.message }}</p>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
  >
    Cancel
  </button>

  <button type="button" class="btn btn-outline-danger" (click)="onDeleteUser()">
    Remove user
  </button>
</div>
